/**
 * @typedef {Object} APIOptions
 * @property {string} route the file to fetch the datasource from
 */

/**
* Get the data from the supplied route
* @param {APIOptions} options
* @returns {Object} Data Source Results
*/
export default async function getData(options) {
    // get the route from the options
    const { route } = options

    // fetch the datasource with the supplied route
    const data = await fetchData({ route })
    console.log(data)
    return data
}

async function fetchData({ route }) {
    // create headers to define that we will be accepting json data
    let headerParams = new Headers()
    headerParams.append('Content-Type', 'application/json')
    headerParams.append('Accept', 'application/json')

    //crate a new request with the url, headers and the GET method as we will only be reading data
    let request = new Request(route, {
        headers: headerParams,
        method: 'GET'
    })

    // preform the fetch if the response is not ok, throw an error with the response text
    const response = await fetch(request)
    if (!response.ok) throw new Error(response.statusText)

    return response.json()
}